export const getCreditCardType = creditNumber => {
  if (/^4/.test(creditNumber)) {
    return { name: "Visa", digits: [13, 16] };
  } else if (/^5[1,2,3,4,5]/.test(creditNumber)) {
    return { name: "Master", digits: [16] };
  } else if (/^3[4,7]/.test(creditNumber)) {
    return { name: "Amex", digits: [15] };
  } else if (
    /^((636368)|(636369)|(438935)|(504175)|(451416)|(636297)|(5067)|(4576)|(4011)|(506699))/.test(
      creditNumber
    )
  ) {
    return { name: "Elo", digits: [16] };
  } else if (/^6(?:011|5[0-9]{2})[0-9]{12}$/.test(creditNumber)) {
    return { name: "Discover", digits: [16] };
  } else if (/^((38)|(60))/.test(creditNumber)) {
    return { name: "Hipercard", digits: [13, 16, 19] };
  } else if (/^35/.test(creditNumber)) {
    return { name: "JCB", digits: [16] };
  } else if (/^50/.test(creditNumber)) {
    return { name: "Aura", digits: [16] };
  }

  return { digits: [] };
};

export const checkCCValidity = value => {
  if (/[^0-9-\s]+/.test(value)){
    return false;
  }

  let nCheck = 0,
    bEven = false;
  value = value.replace(/\D/g, "");

  for (var n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n)
    let nDigit = parseInt(cDigit, 10);
    nDigit = bEven ? nDigit * 2 : nDigit
    if (bEven && nDigit > 9){
      nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 === 0;
};
